import { Stack, Text, useText } from "@sveabank/cc-common";
import { useEffect } from "react";
import Content from "../../components/content";
import { withLoader } from "../../hoc/with-loader";
import { usePageContext } from "../../hooks/context";
import { isFeatureEnabled } from "../../utils/feature-flags";
import { removeRevision } from "../../utils/storage";
import Applications from "./applications";
import { useDashboard } from "./hooks";

const DashboardPage = () => {
	const { getLoggedInUser } = usePageContext(useDashboard);
	const [t, texts] = useText();

	const user = getLoggedInUser();

	useEffect(() => {
		// Remove revision from previous applications
		removeRevision();
	}, []);

	return (
		<Content my={8}>
			<Stack gap={8}>
				<Text component="h2" bold italic className="text-text-headline text-2xl">
					{t(texts.dashboardPage.title, user.bankIdUser.correspondenceName)}
				</Text>
				<Stack gap={1}>
					{isFeatureEnabled("startCompany") ? (
						<>
							<Text>{t(texts.dashboardPage.subDescription1)}</Text>
							<Text>{t(texts.dashboardPage.subDescription2)}</Text>
						</>
					) : (
						<Text>{t(texts.dashboardPage.subDescriptionNewCompanyDisabled)}</Text>
					)}
				</Stack>

				<Applications />
			</Stack>
		</Content>
	);
};

export default withLoader(useDashboard, DashboardPage);
